var exports = {
  "vK": "xe564cbfb--3f4bdc--banner",
  "Qs": "xe564cbfb--3f4bdc--content",
  "Qq": "xe564cbfb--3f4bdc--text",
  "wx": "xe564cbfb--3f4bdc--header",
  "h_": "xe564cbfb--3f4bdc--description",
  "Pf": "xe564cbfb--3f4bdc--label",
  "Lr": "xe564cbfb--3f4bdc--house-1",
  "So": "xe564cbfb--3f4bdc--house-2",
  "w9": "xe564cbfb--3f4bdc--coin",
  "$T": "xe564cbfb--3f4bdc--tablet-coin",
};

module.exports = exports;
